import { number } from '@jira/platform__common-url-transform-presets/src/index.tsx';
import type {
	ListWorkFlowsFilter,
	WorkflowOrderBy,
	ApiQueryParams,
} from './ApiQueryParams.types.tsx';
import { defaultListWorkFlowsFilter, DEFAULT_PAGE_SIZE } from './packageName.constants.tsx';
import { trimSearchFilter } from './trimSearchFilter.tsx';

export const toUrlTransformer = (
	filter?: ListWorkFlowsFilter,
): {
	pageNumber: number | undefined;
	searchFilter: string | undefined;
	orderBy: WorkflowOrderBy | undefined;
	isActive: boolean | undefined;
	pageSize: number | undefined;
} => {
	const { pageNumber, searchFilter, orderBy, isActive, pageSize } = filter || {};
	return { pageNumber, searchFilter, orderBy, isActive, pageSize };
};

export const fromUrlTransformer = (params: { [key: string]: string }): ListWorkFlowsFilter => {
	const { pageNumber, searchFilter, orderBy, isActive, pageSize } = params;
	const parsedNumber = Number.isNaN(number.parse(pageNumber))
		? defaultListWorkFlowsFilter.pageNumber
		: number.parse(pageNumber);
	const parsedSize = Number.isNaN(number.parse(pageSize))
		? defaultListWorkFlowsFilter.pageSize
		: number.parse(pageSize);
	const parsedOrderBy: WorkflowOrderBy | undefined =
		orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated'
			? orderBy
			: undefined;

	const isActiveFinal =
		isActive != null ? isActive === 'true' : defaultListWorkFlowsFilter.isActive;
	return {
		...defaultListWorkFlowsFilter,
		pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
		pageSize: parsedSize != null ? Number(parsedSize) : undefined,
		searchFilter,
		orderBy: parsedOrderBy,
		isActive: isActiveFinal,
	};
};

export const toApiUrlTransformer = (filter: ListWorkFlowsFilter): ApiQueryParams => {
	const fullFilter = { ...defaultListWorkFlowsFilter, ...filter };
	const { pageNumber = 1, pageSize = DEFAULT_PAGE_SIZE } = fullFilter;

	let requestParams = {
		maxResults: pageSize,
		startAt: (pageNumber - 1) * pageSize,
		orderBy: fullFilter.orderBy,
		queryString: trimSearchFilter(fullFilter.searchFilter),
		isActive: fullFilter.isActive,
	};

	if (fullFilter.expand != null) {
		// @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
		requestParams = { ...requestParams, expand: fullFilter.expand.join(',') };
	}

	return requestParams;
};
